export const COPY_FORMATS = ['CSV'] as const;
export type CopyFormat = (typeof COPY_FORMATS)[number];

export const EXPORT_FORMATS = ['CSV', 'XLSX'] as const;
export type ExportFormat = (typeof EXPORT_FORMATS)[number];
export type ExportScope = 'current' | 'all';
export type ExportTarget = 'tile' | 'dashboard';

export interface ExportRequest {
  dashboardId: string;
  fund?: string;
  format: ExportFormat;
  scope: ExportScope;
  tileId: string;
  target?: ExportTarget;
  fileNameParts?: (string | null | undefined)[];
  filterValues?: { key: string; values?: string[] }[];
}
